
(() => {
  let swiperElem
  let prevEl
  let nextEl
  let thumbnailSwiper

  function getActiveThumbnailIndex () {
    if (!thumbnailSwiper) {
      return -1
    }

    const slides = thumbnailSwiper.slides && typeof thumbnailSwiper.slides.length === 'number'
      ? Array.from(thumbnailSwiper.slides)
      : Array.from(
        thumbnailSwiper.el?.querySelectorAll('.product-medias__thumbnail.swiper-slide') ||
          document.querySelectorAll('.product-medias__thumbnail.swiper-slide')
      )

    return slides.findIndex(slide => slide.classList.contains('f--active'))
  }

  function syncThumbnailSlider (activeIndex = getActiveThumbnailIndex()) {
    if (thumbnailSwiper && activeIndex >= 0) {
      thumbnailSwiper.slideTo(Math.max(activeIndex - 1, 0), 200)
    }
  }

  function initThumbnailSlider () {
    const thumbnailContainer = document.querySelector('.product-medias__thumbnails')
    const SwiperCtor = swiperElem?.swiper?.constructor || window.Swiper

    if (!thumbnailContainer || thumbnailContainer.classList.contains('swiper-container-initialized')) {
      return
    }

    const thumbnails = [...thumbnailContainer.querySelectorAll('.product-medias__thumbnail')]

    if (thumbnails.length < 2 || typeof SwiperCtor === 'undefined') {
      return
    }

    thumbnailSwiper = new SwiperCtor(thumbnailContainer, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      threshold: 10,
      simulateTouch: true,
      allowTouchMove: true,
      freeMode: true,
      freeModeSticky: false,
      touchStartPreventDefault: false,
      touchReleaseOnEdges: true,
      resistanceRatio: 0.85,
      watchOverflow: false,
    })

    syncThumbnailSlider(swiperElem?.swiper?.realIndex ?? 0)
  }

  function run () {
    swiperElem = document.querySelector('.product-medias__main .swiper-container.swiper-container-initialized')

    if (swiperElem?.swiper) {
      prevEl = swiperElem.querySelector('.swiper-button-prev')
      prevEl
        .addEventListener('click', () => {
          swiperElem.swiper.slidePrev()
        })

      nextEl = swiperElem.querySelector('.swiper-button-next')
      nextEl
        .addEventListener('click', () => {
          swiperElem.swiper.slideNext()
        })

      if (swiperElem.swiper.slides.length > 1) {
        nextEl.classList.remove('swiper-button-disabled')
      }

      initThumbnailSlider()
      swiperElem.swiper.on('slideChange', () => {
        syncThumbnailSlider(swiperElem.swiper.realIndex)


        nextEl.classList.toggle('swiper-button-disabled', swiperElem.swiper.isEnd)
        prevEl.classList.toggle('swiper-button-disabled', swiperElem.swiper.isBeginning)
      })
    } else {
      setTimeout(run, 100)
    }
  }

  run()
})()
